import { InternalSubCard } from '@app/components/card';
import { CustomAvatar, CustomAvatarGroup } from '@app/components/custom-avatar';
import { Strings } from '@app/constants';
import { IPersonalInfoSchema } from '../types';
import { IProjectDetails } from '@app/modules/projects';

interface Props {
  userData: IProjectDetails;
}

export const ProjectsInfo = ({ userData }: Props) => {
  const subCards = userData?.projectContributions?.map((project: any, index: number) => ({
    subTitle: project.projectName,
    fields: [
      Strings.projects.managers,
      ...project.userTasks.map((task: any) => task.listName),
      Strings.projects.totalTasks,
    ],
    data: [
      <CustomAvatarGroup max={3} key={index}>
        {project?.managers?.map((team: IPersonalInfoSchema, index: number) => (
          <CustomAvatar key={index} name={`${team.firstName} ${team.lastName}`} color="info" />
        ))}
      </CustomAvatarGroup>,
      ...project.userTasks.map((task: any) => task.cardCount),
      project.totalTasks,
    ],
  }));

  return (
    <InternalSubCard
      title={Strings.profile.projectsTasksInfo}
      subCards={subCards}
      height={'270px'}
      iconImg="ic_projects"
    />
  );
};
